export const ITEMS_PATH = "/restock/data-management/items";

const isItemsPath = (pathname: string) => pathname === ITEMS_PATH || pathname.startsWith(`${ITEMS_PATH}/`);

export default isItemsPath;
